
import { _ASSET_TYPE, changeKitchenStyle } from '@rhinov/asset-manager-service'
import async from 'async-es';
import { ReplaceArrangementCommand } from './ReplaceArrangementCommand';
import { InteractiveProjectHandler } from '../interactiveProjectHandler';
import { ArrangementObject, Commands, Events, eventsManager, Floor, KitchenTool, Scene } from '@rhinov/savane-js';

export class ChangeKitchenStyleCommand extends Commands.Command {
    private _handler: any;
    private _arrangements: any;
    private _scene: Scene;
    private _floor: Floor;
    private _style: any;
    private _coatingId: any;
    private _commands: any[];

    constructor(handler: InteractiveProjectHandler, arrangements: Array<ArrangementObject>, style: string, coatingId: string) {
        super();

        this._handler = handler;
        this._arrangements = arrangements;
        this._scene = arrangements[0].scene!;
        this._floor = arrangements[0].floor!;
        this._style = style;
        this._coatingId = coatingId;
        this._commands = [];
    }

    name = () : string => {
        return "ChangeKitchenStyleCommand";
    }

    assetType = () : _ASSET_TYPE => {
        return _ASSET_TYPE.ARRANGEMENTS;
    }

    undo = () : void => {
        for (var i = this._commands.length - 1; i >= 0; --i) {
            this._commands[i].undo();
        }

        KitchenTool.KitchenManager.setFurnitureFinishes(this._floor);
        eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);
        this._handler.scene.render();
        eventsManager.instance.dispatch(Events.RHINOV_FORMAT_UPDATED, { scene: this._scene, command: null });
    }

    redo = () : void => {
        this._exec(true);
    }

    execute = () : void => {
        this._exec(false);
    }

    _exec = (redo: any) : void => {
        this._commands = [];

        changeKitchenStyle(this._arrangements, this._style, this._coatingId, (result: any) => {
            if (this._arrangements.length === 0) return;

            var addedEntity = null;
            for (var i = 0; i < this._arrangements.length; i++) {
                var oldArrangement = this._arrangements[i];

                if (oldArrangement.isArrangementObjectEntity()) {
                    var entity = result[i].new_object_entity;

                    // No entity tu substitute, continue loop
                    if (!entity) {
                        continue;
                    }

                    // keep ids
                    entity._id = oldArrangement._id;
                    addedEntity = entity;
                    this._commands.push(new ReplaceArrangementCommand(this._handler, oldArrangement, entity, true));
                }
            }

            async.eachSeries(this._commands, (command: any, callback: any) => {
                command._exec(true, () => {
                    callback();
                });
            }, () => {
                KitchenTool.KitchenManager.setFurnitureFinishes(this._floor);
                eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);
                this._handler.scene.render();
                eventsManager.instance.dispatch(Events.RHINOV_FORMAT_UPDATED, { scene: this._scene, command: redo ? null : this, newKitchenStyleInfos: result });
            });
        });
    }

}
